import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-stock-get',
  templateUrl: './stock-get.component.html',
  styleUrls: ['./stock-get.component.css']
})
export class StockGetComponent implements OnInit {
    stockKeyno;

    public edit?: Edit;

    public selectListProdBeoMethods: ProdBeoMethodItem[] = [];

    public itemsListOwnKpis: Item[] = [];

    public saving = false;

    public productButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_keyno ?? '' }
    ];

    public stockValueButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockbatchlist', gotoParms: () => this.edit!.stock_keyno ?? '' }
    ];

    public stockBatchQtyButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockstockbatchassigned', gotoParms: () => this.edit!.stock_keyno ?? '' }
    ];

    public numberOfLocationsButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockonlocation', gotoParms: () => ({ stock_keyno: this.edit!.stock_keyno, functionname: 'stock' }) }
    ];

    public stockValueOtherButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockall', gotoParms: () => this.edit!.stock_keyno ?? '' }
    ];

    public stockIncomingButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockincoming', gotoParms: () => this.edit!.stock_keyno ?? '' }
    ];

    public stockOutgoingButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockoutgoing', gotoParms: () => this.edit!.stock_keyno ?? '' }
    ];

    public stockLocationNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-search', goto: 'selectstocklocation', gotoParms: () => this.edit!.stockplace_id ?? '' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockKeyno) {
            this.edit = (await this.datatask.Post(169, { stock_keyno: this.stockKeyno }))[0];
        }
    }

    private async loadProdBeoMethods() {
        this.selectListProdBeoMethods = await this.datatask.Post(997);
    }

    private async loadOwnKpis() {
        if (!!this.edit) {
            this.itemsListOwnKpis = await this.datatask.Post(3338, { stock_keyno: this.edit.stock_keyno });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(473, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'selectreport':
                this.stateService?.go('selectreport', {
                    webpage_name: 'stockget',
                    argtype: 'stock_keyno',
                    argvalue: this.edit?.stock_keyno
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadProdBeoMethods();
        this.loadOwnKpis();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stock_keyno: string;
    stockplace_id: string;
    prod_id: string;
    prod_name: string;
    prodsize_keyno: string;
    prodchoice_keyno: string;
    stock_stockvalue: string;
    stock_incoming: string;
    stock_outgoing: string;
    stock_disposable: string;
    allow_access_product: string;
    buttontext_creatpo: string;
    stockbatch_qty_assigned: string;
    last_counted_info: string;
    stocklocation_keyno: number;
    stock_stockvalue_other: string;
    stock_unit_name: string;
    stockplace_name: string;
    show_requisition: string;
    show_stockcorrection: string;
    prodbeomethod_no: string;
    show_setting: string;
    stocklocation_name: string;
    nbr_of_locations: string;
    floating_location: string;
    prod_keyno: string;
    show_stocktransallocation: string;
    stock_stockvalue_ex_assigned: string;
    stock_minimum: string;
    stock_std_orderquantity: string;
    stock_maximum: string;
    show_stockminmaxadjust: string;
    show_own_kpi: string;
}

interface ProdBeoMethodItem {
    prodbeomethod_no: number;
    prodbeomethod_name: string;
    orderby: number;
}
